import React, { useEffect } from 'react';
import { Box, Container, Divider, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useAuth from 'src/hooks/useAuth';
import Page from 'src/components/Page';
import useStore from 'src/hooks/useStore';
import { Header } from 'src/components/Headers';
import { SERVICE_CLIENT_AUTH } from 'src/constants/permissions';
import { useHistory, useParams } from 'react-router-dom';
import { ServiceClientVehicleForm } from '../components';
import { TCreateVehicleFormikValues } from '../components/types';
import { useServiceClient } from 'src/hooks';
import { ServiceClient } from 'src/constants/modules/serviceClient';
import { CapitalizeNames } from 'src/utils/capitalize';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100%',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
}));

export const CreateServiceClientVehicle = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { user } = useAuth();
    const { getStores } = useStore();
    const history = useHistory();
    const { serviceClientId } = useParams<{ serviceClientId: string }>();
    const { client, createServiceClientVehicle, getServiceClientById } =
        useServiceClient();

    useEffect(() => {
        if (user._id) getStores();
    }, [user]);

    useEffect(() => {
        if (serviceClientId) getServiceClientById(serviceClientId);
    }, [serviceClientId]);

    const handleSubmit = async (values: TCreateVehicleFormikValues) => {
        const response = await createServiceClientVehicle(
            serviceClientId,
            values
        );
        if (response)
            history.push(`/management/service-clients/${serviceClientId}`);
    };

    return (
        <Page className={classes.root} title={t('serviceClient.CreateVehicle')}>
            <Container maxWidth="lg">
                <Header
                    module={ServiceClient.name}
                    route={ServiceClient.route}
                    crud={{
                        goBack: true,
                    }}
                    permission={SERVICE_CLIENT_AUTH}
                    title={CapitalizeNames(client?.name)}
                />
                <Divider />
                <Box mt={3}>
                    <ServiceClientVehicleForm
                        mode="create"
                        onSubmit={handleSubmit}
                    />
                </Box>
            </Container>
        </Page>
    );
};
